<template>
  <div class="mb-5 bg-white">
    <b-table stacked="lg" :fields="fieldsItemsCourse" :items="courseUnpublish" class="text-center">
      <template v-slot:cell(fullname)="data">{{data.item.fullname}}</template>

      <template v-slot:cell(editCourse)="row" >
        <div class="input-checkbox rtl text-right">
          <div class="md-checkbox">
            <input
              type="checkbox"
              :id="row.index+'Unpublish'"
              v-model="row.item.editable"
              @change="editPerm(row.item, row.index,'courseUnpublish')"
            >
            <label
              :for="row.index+'Unpublish'"
              class="font-14"
            >{{row.item.editable ? 'اخذ' : 'صدور'}}</label>
          </div>
        </div>
      </template>
      <!-- <template v-slot:cell(row-enrollPerm)="row">
                          <div class="input-checkbox rtl text-right">
                            <div class="md-checkbox">
                              <input type="checkbox" :id="row.index+'Publish'" v-model="row.item.editable" @change="editPerm(row.item, row.index,'coursePublish')">
                              <label :for="row.index+'Publish'" class="font-14">{{row.item.editable ? 'اخذ' : 'صدور'}}</label>
                            </div>
                          </div>
      </template>-->
      <template v-slot:cell(action)="row" >
        <div class="d-flex justify-content-center">
          <button
            class="bttn-material-circle ml-2 bttn-md bttn-danger text-center"
            v-ripple
            @click="removeCourses(row.item, row.index,true)"
            :title="'حذف'"
          >
            <i class="flaticon-dustbin"></i>
          </button>
          <button
            class="bttn-material-circle bttn-md bttn-success text-center"
            v-ripple
            @click="activeteCourses(row.item, row.index,true)"
            :title="'فعال کردن'"
          >
            <i class="flaticon-check-2"></i>
          </button>
        </div>
      </template>
    </b-table>
    <page-number :lengthList="lengthListUnPub" @callBack="pageCallBack"/>
  </div>
</template>

<script>
export default {
  name: "course-unpublish",
  props: ["items"],
  data() {
    return {
      fieldsItemsCourse: [
        { key: "course_title", label: "نام دوره" },
        { key: "fullname", label: "نام مدرس" },
        { key: "category", label: "دسته" },
        { key: "editCourse", label: "مجوز ویرایش" },
        { key: "enrollPerm", label: "مجوز ثبت نام" },
        { key: "action", label: "عملیات" }
      ]
    };
  },
  computed: {
    lengthListUnPub() {
      return this.$store.state.dashboardAllCourses.lengthListUnPub
    },
    courseUnpublish() {
      return this.$store.state.dashboardAllCourses.courseUnpublish
    },
  },
  methods: {
    pageCallBack(page) {
      this.$emit('getCourseUnPublish', page)
    },
    async editPerm(item, index, activeArray) {
      try {
        this.isLoading = true;
        let { data } = await axios.post("/course/course-edit-perm", {
          state: item.editable,
          id: item.id
        });
        if (data.state !== 200) {
          this.$store.commit("notifications/error", {
            message: this.$t("message.request.someProblem"),
            title: ""
          });
          return;
        }
        this.isLoading = false;
        this.$store.commit(
          "notifications/success",
          { message: this.$t("message.request.done"), title: "" },
          { root: true }
        );
        // this.$set(this[activeArray][index], 'editable', item.editable)
      } catch (error) {
        console.log(error);
      }
    },
    async removeCourses(item, index, state) {
      let result = window.confirm("آیا مطمئن هستید؟");
      if (!result) return;
      this.isLoading = true;
      try {
        let { data } = await axios.post("/course/delete-course", {
          id: item.id
        });
        if (data.state !== 200) {
          this.$store.commit("notifications/error", {
            message: this.$t("message.request.someProblem"),
            title: ""
          });
          this.isLoading = false;
          return;
        }
        if (state) {
          this.courseUnpublish.splice(index, 1);
        } else {
          this.coursePublish.splice(index, 1);
        }
        this.$store.commit(
          "notifications/success",
          { message: this.$t("message.request.done"), title: "" },
          { root: true }
        );
        this.isLoading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async activeteCourses(item, index, state) {
      try {
        let { data } = await axios.post("/course/course-pulish", {
          id: item.id,
          state: state
        });
        if (data.state !== 200) return;

        this.$store.commit(
          "notifications/success",
          { message: this.$t("message.request.done"), title: "" },
          { root: true }
        );
        this.items.splice(index, 1);

      } catch (error) {
        console.log(error);
      }
    },
  }
};
</script>




// WEBPACK FOOTER //
// src/components/dashboard-component/courses/course-unpublish.vue